import { RoutePaths } from '@interfaces/routePaths'
import { Base } from '@views/Community/Base'
import { Invites } from '@views/Community/Invites'
import { Members } from '@views/Community/Members'
import { Partners } from '@views/Community/Partners'
import { Pending } from '@views/Community/Pending'
import { BaseLayout } from '../BaseLayout'

export const COMMUNITY_PATHS = [
  {
    path: RoutePaths.COMMUNITY,
    element: <BaseLayout />,
    children: [
      {
        path: RoutePaths.COMMUNITY_INVITES,
        element: (
          <Base>
            <Invites />
          </Base>
        ),
      },
      {
        path: RoutePaths.COMMUNITY_PENDING,
        element: (
          <Base>
            <Pending />
          </Base>
        ),
      },
      {
        path: RoutePaths.COMMUNITY_MEMBERS,
        element: (
          <Base>
            <Members />
          </Base>
        ),
      },
      {
        path: RoutePaths.COMMUNITY_PARTNERS,
        element: (
          <Base>
            <Partners />
          </Base>
        ),
      },
    ],
  },
]
